import LeaderboardTab from './LeaderboardTab';

export default function LeaderboardRouter() {
    return <LeaderboardTab />;
}
